import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={37}
    height={12}
    viewBox="0 0 37 12"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M.675 11.059h1.642v-.918c.444.506 1.076 1.164 2.515 1.164 2.73 0 3.711-2.56 3.711-4.08 0-2.014-1.48-4.027-3.752-4.027-.835 0-1.708.315-2.328.945V.925H.675v10.133Zm1.683-3.903c0-1.109.847-2.286 2.22-2.286 1.13 0 2.179.89 2.179 2.368 0 1.478-.982 2.397-2.152 2.397-1.049 0-2.246-.795-2.246-2.479h-.001Z"
    />
    <path
      stroke="currentColor"
      strokeOpacity={0.04}
      strokeWidth={0.095}
      d="M2.416.973v3.285l.08-.082c.61-.62 1.472-.93 2.295-.93 2.24 0 3.705 1.985 3.705 3.978 0 .752-.243 1.762-.823 2.583-.58.82-1.493 1.45-2.841 1.45-.712 0-1.221-.162-1.607-.385-.386-.224-.651-.51-.873-.762l-.083-.095v.996H.723V.973h1.693Zm2.162 3.85c-1.404 0-2.268 1.204-2.268 2.334v.047h.003c.022 1.68 1.23 2.478 2.292 2.478 1.198 0 2.2-.943 2.2-2.444 0-1.504-1.07-2.415-2.227-2.415Z"
    />
    <path
      fill="currentColor"
      d="M16.482 8.073c.055-.246.108-.56.108-.917 0-1.916-1.413-3.958-3.86-3.958s-3.928 1.931-3.928 4.08c0 2.15 1.668 4.026 3.941 4.026 1.762 0 3.174-1.274 3.605-2.643h-1.883c-.337.63-.928.972-1.722.972-1.278 0-1.976-1.069-2.058-1.561h5.797v.001ZM10.631 6.61c.335-1.41 1.385-1.74 2.11-1.74.956 0 1.817.52 2.018 1.74H10.63Z"
    />
    <path
      stroke="currentColor"
      strokeOpacity={0.04}
      strokeWidth={0.095}
      d="M12.73 3.246c2.415 0 3.812 2.014 3.812 3.91 0 .333-.048.63-.099.868H10.63l.009.056c.043.258.244.658.595.992.351.335.857.608 1.51.608.799 0 1.401-.34 1.75-.971h1.787c-.448 1.327-1.824 2.548-3.537 2.548-2.244 0-3.893-1.854-3.893-3.98 0-2.127 1.464-4.031 3.88-4.031Zm.011 1.576c-.369 0-.823.084-1.227.348-.406.266-.76.712-.93 1.428l-.014.058h4.245l-.01-.055c-.101-.62-.372-1.066-.742-1.356-.37-.29-.836-.423-1.322-.423Z"
    />
    <path
      fill="currentColor"
      d="M24.695 3.458h-1.641v.958h-.028c-.054-.109-.955-1.218-2.475-1.218-2.072 0-3.739 1.683-3.739 4.012 0 2.533 1.708 4.094 3.632 4.094.941 0 2.044-.506 2.61-1.19v.944h1.64v-7.6ZM23 7.238c0 1.41-.942 2.396-2.18 2.396-1.237 0-2.22-1.055-2.22-2.34 0-1.137.753-2.425 2.22-2.425 1.063 0 2.18.795 2.18 2.368Z"
    />
    <path
      stroke="currentColor"
      strokeOpacity={0.04}
      strokeWidth={0.095}
      d="M20.551 3.246c.748 0 1.345.272 1.761.56.208.143.37.29.484.406.057.06.102.11.134.15.033.04.05.066.054.075l.014.026h.103v-.958h1.547v7.505H23.1V9.982l-.084.102c-.556.673-1.645 1.173-2.573 1.173-1.895 0-3.584-1.537-3.584-4.047 0-2.305 1.648-3.964 3.691-3.964Zm.27 1.576c-.748 0-1.317.33-1.697.803a2.712 2.712 0 0 0-.57 1.668c0 1.31 1.001 2.39 2.268 2.39 1.267-.001 2.226-1.013 2.226-2.445 0-1.601-1.14-2.416-2.226-2.416Z"
    />
    <path
      fill="currentColor"
      d="M25.518 11.06h1.79V7.267c0-.809 0-2.397 1.425-2.397 1.103 0 1.493.931 1.493 1.972v4.218h1.79V7.267c0-.479-.014-1.232.268-1.684.256-.438.74-.711 1.238-.711 1.413 0 1.413 1.534 1.413 1.972v4.218h1.79V6.625c0-1.123-.27-1.849-.566-2.246-.269-.384-.996-1.177-2.462-1.177-.524 0-1.627.054-2.407 1.19a2.5 2.5 0 0 0-2.152-1.19c-1.29 0-1.803.657-1.951.903h-.027v-.643h-1.642v7.6-.002Z"
    />
    <path
      stroke="currentColor"
      strokeOpacity={0.04}
      strokeWidth={0.095}
      d="M33.697 3.25c1.265 0 1.97.597 2.303.999l.12.157v.002c.29.387.557 1.1.557 2.217v4.39h-1.695v-4.17c0-.22 0-.722-.18-1.17a1.376 1.376 0 0 0-.434-.594c-.208-.158-.484-.256-.846-.256-.45 0-.89.215-1.169.573l-.11.16c-.146.235-.214.545-.246.852-.032.307-.03.618-.03.857v3.746h-1.694v-4.17c0-.526-.098-1.03-.34-1.403-.244-.377-.633-.617-1.2-.617-.366 0-.644.102-.854.271-.209.169-.347.401-.438.656-.181.507-.18 1.114-.18 1.517v3.746h-1.695V3.51h1.546v.644h.102l.013-.024c.142-.235.64-.88 1.91-.88.397 0 1.426.094 2.113 1.17l.039.059.04-.059c.765-1.116 1.847-1.17 2.368-1.17Z"
    />
  </svg>
);
export default SvgComponent;
